export default __webpack_public_path__ + "static/media/msync3.91986df9.png";